import { useAppSelector } from 'appState/store'
import { softphone } from 'features/calls/utils/softphone'
import styled from 'styled-components'
import { TakeOverTypeEnum } from '@outbound-ai/softphone'

export const BrowserMutedNotification = () => {
  const { takeOver } = useAppSelector((state) => state.calls.talkToPayorRepLiveCall)

  const handleUnmute = async () => {
    await softphone.resumeAudioContext()
    if (!takeOver.type || TakeOverTypeEnum.browser === takeOver.type) {
      softphone.unmuteAudio()
    }

    if (TakeOverTypeEnum.browser === takeOver.type) {
      softphone.unmuteMicrophone()
    }
  }

  return (
    <Div>
      <p>Your browser silenced incoming call audio.</p>
      <span role="button" onClick={handleUnmute}>
        Listen to Audio?
      </span>
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  vertical-align: middle;
  position: relative;
  bottom: -0.125rem;
  padding-inline-end: 0.5rem;

  p {
    color: ${({ theme }) => theme.colors.primary.darker};
  }

  span {
    color: ${({ theme }) => theme.colors.info.darker};
  }
`
